import calendarIconGray from "../../assets/svg-assets/calendar_9e9e9e.svg";

const PRIMARY_COLOR = import.meta.env.VITE_PRIMARY_COLOR;
const SECONDARY_COLOR = import.meta.env.VITE_SECONDARY_COLOR;

export const appTheme = {
    light: "light",
    dark: "dark",
};

export const COLOR_THEME_VARS = {
    light: {
        "--panel-color": "#fff",
        "--panel-secondary-color": "#fafafa",
        "--panel-tertiary-color": "#f5f5f5",
        "--text-color": "#212121",
        "--text-secondary-color": "#616161",
        "--text-tertiary": "#757575",
        "--text-icon-color": "#9e9e9e",
        "--separator-color": "#e0e0e0",
        "--primary-color": PRIMARY_COLOR || "#F54550",
        "--primary-text-color": "#fff",
        "--primary-40-color": "color-mix(in srgb, var(--primary-color) 20%, #fff)",
        "--primary-50-color": SECONDARY_COLOR || "#DB1D1F",
        "--link-color": PRIMARY_COLOR || "#F54550",
        "--button-secondary-color": "#181A1D",
        "--button-secondary-hover-color": "#30353A",
        "--disable-text-color": "#BDBDBD",
        "--disable-border-color": "#EEEEEE",
        "--danger-color": "#d32f2f",
        "--danger-secondary-color": "#f44336",
        "--danger-separator-color": "#ef9a9a",
        "--danger-background-color": "#ffebee",
        "--success-color": "#2e7d32",
        "--success-secondary-color": "#43a047",
        "--success-separator-color": "#81c784",
        "--success-background-color": "#e8f5e9",
        "--yellow-background-color": "#fff9c4",
        "--box-shadow-chat": `0px 10px 20px rgba(0, 0, 0, 0.04),
        0px 2px 6px rgba(0, 0, 0, 0.04),0px 0px 1px rgba(0, 0, 0, 0.04)`,
        "--transition-delay": ".3s",
        "--primary-box-shadow": `0 0 1px rgba(0, 0, 0, .16),
        0 2px 4px rgba(0, 156, 204, .28), 0 6px 12px rgba(0, 156, 204, .4)`,
        "--datepicker-icon-default": `url("${calendarIconGray}")`,
    },

    dark: {
        "--panel-color": "#34434A",
        "--panel-secondary-color": "#2D3A41",
        "--panel-tertiary-color": "#263238",
        "--text-color": "#E4ECF0",
        "--text-secondary-color": "#90A4AE",
        "--text-tertiary": "#9FB3BD",
        "--text-icon-color": "#9e9e9e",
        "--separator-color": "#455A64",
        "--primary-color": PRIMARY_COLOR || "#E63437",
        "--primary-text-color": "#fff",
        "--primary-40-color": "color-mix(in srgb, var(--primary-color) 20%, #000)",
        "--primary-50-color": SECONDARY_COLOR || "#1b4f61",
        "--link-color": PRIMARY_COLOR || "#FF747D",
        "--button-secondary-color": "#1A2328",
        "--button-secondary-hover-color": "#181A1D",
        "--danger-color": "#F37F7D",
        "--danger-secondary-color": "#D32F2F",
        "--danger-separator-color": "#893B3E",
        "--danger-background-color": "#51363B",
        "--success-color": "#66BB6A",
        "--success-secondary-color": "#2E7D32",
        "--success-separator-color": "#2A5535",
        "--success-background-color": "#284137",
        "--yellow-background-color": "#696406",
        "--box-shadow-chat": `0px 10px 20px rgba(0, 0, 0, 0.30),
        0px 2px 6px rgba(0, 0, 0, 0.30), 0px 0px 1px rgba(0, 0, 0, 0.04)`,
        "--transition-delay": ".3s",
        "--primary-box-shadow": `0 0 1px rgba(0, 0, 0, .16),
        0 2px 4px rgba(0, 156, 204, .28), 0 6px 12px rgba(0, 156, 204, .4)`,
        "--datepicker-icon-default": `url("${calendarIconGray}")`,
    },
};
